var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlugCabinets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 14L11 16M7 12L12 17L10.5 18.5C10.1737 18.8371 9.78351 19.1059 9.35225 19.2907C8.921 19.4755 8.45728 19.5727 7.98811 19.5765C7.51894 19.5803 7.0537 19.4907 6.61951 19.3129C6.18531 19.1351 5.79084 18.8727 5.45907 18.5409C5.12731 18.2092 4.86489 17.8147 4.6871 17.3805C4.50931 16.9463 4.41971 16.4811 4.42352 16.0119C4.42733 15.5427 4.52447 15.079 4.70929 14.6477C4.8941 14.2165 5.16289 13.8263 5.5 13.5L7 12ZM17 12L12 7L13.5 5.5C13.8263 5.16289 14.2165 4.8941 14.6477 4.70929C15.079 4.52447 15.5427 4.42733 16.0119 4.42352C16.4811 4.41971 16.9463 4.50931 17.3805 4.6871C17.8147 4.86489 18.2092 5.12731 18.5409 5.45907C18.8727 5.79084 19.1351 6.18531 19.3129 6.61951C19.4907 7.0537 19.5803 7.51894 19.5765 7.98811C19.5727 8.45728 19.4755 8.921 19.2907 9.35225C19.1059 9.78351 18.8371 10.1737 18.5 10.5L17 12ZM3 21L5.5 18.5L3 21ZM18.5 5.5L21 3L18.5 5.5ZM10 11L8 13L10 11Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugCabinets);
export default __webpack_public_path__ + "static/media/PlugCabinets.a9d285675cf2d187303ba0578948920a.svg";
export { ForwardRef as ReactComponent };